import { GROUND_ROW, cutPit, fillRect, freeze, makeGrid, setCell, stampPipe, type EntitySpawn, type LevelDef } from "./types";

const WALL_H = 15;

export function buildWorld12(): LevelDef {
  const width = 192;
  const grid = makeGrid(width, false);
  fillRect(grid, 0, 0, width, 2, "S");
  fillRect(grid, 0, GROUND_ROW, width, 2, "=");
  fillRect(grid, 0, 2, 2, GROUND_ROW - 2, "S");

  const entities: EntitySpawn[] = [];
  const pipes: LevelDef["pipes"] = [];

  stampPipe(grid, 2, 3);
  pipes.push({ tx: 2, height: 3 });

  fillRect(grid, 10, 9, 8, 1, "#");
  setCell(grid, 12, 9, "!");
  setCell(grid, 15, 9, "?");
  fillRect(grid, 18, 5, 6, 1, "#");
  setCell(grid, 20, 5, "?");

  stampPipe(grid, 24, 3);
  pipes.push({ tx: 24, height: 3 });
  entities.push({ kind: "plant", tx: 24 });

  fillRect(grid, 32, 8, 3, 5, "S");
  fillRect(grid, 38, 6, 2, 7, "S");
  cutPit(grid, 42, 3);
  fillRect(grid, 46, 10, 4, 1, "-");
  entities.push({ kind: "platform", tx: 47, ty: 10, tiles: 3, axis: "x", span: 4 });

  stampPipe(grid, 58, 4);
  pipes.push({ tx: 58, height: 4 });
  entities.push({ kind: "plant", tx: 58 });

  fillRect(grid, 64, 9, 10, 1, "#");
  setCell(grid, 68, 9, "1");
  setCell(grid, 70, 9, "?");
  fillRect(grid, 74, 5, 4, 1, "#");

  entities.push({ kind: "spring", tx: 80, ty: GROUND_ROW });
  fillRect(grid, 82, 3, 8, 1, "S");

  stampPipe(grid, 92, 2);
  pipes.push({ tx: 92, height: 2 });

  fillRect(grid, 98, 7, 2, 6, "S");
  cutPit(grid, 102, 4);
  fillRect(grid, 104, 9, 3, 1, "-");
  entities.push({ kind: "platform", tx: 103, ty: 8, tiles: 2, axis: "y", span: 3 });

  fillRect(grid, 112, 9, 6, 1, "#");
  setCell(grid, 114, 9, "!");
  stampPipe(grid, 122, 3);
  pipes.push({ tx: 122, height: 3 });
  entities.push({ kind: "plant", tx: 122 });

  fillRect(grid, 130, 8, 12, 1, "#");
  for (let x = 132; x < 140; x += 2) setCell(grid, x, 8, "?");
  fillRect(grid, 136, 6, 6, 1, "S");

  stampPipe(grid, 146, 2);
  pipes.push({
    tx: 146,
    height: 2,
    dest: { levelId: "1-3", enter: "pipe-down" },
  });
  fillRect(grid, 152, 6, 3, GROUND_ROW - 6, "S");
  fillRect(grid, 140, 3, 16, 1, "S");
  for (let x = 140; x < 156; x += 1) {
    setCell(grid, x, 1, ".");
    setCell(grid, x, 2, ".");
  }

  fillRect(grid, 154, 0, 38, 1, "S");
  for (let x = 156; x < 188; x += 1) {
    setCell(grid, x, 1, ".");
    setCell(grid, x, 2, ".");
  }
  fillRect(grid, 156, GROUND_ROW, 32, 2, "=");
  fillRect(grid, 188, 0, 4, WALL_H, "S");

  const warpPipes = [160, 168, 176];
  for (const tx of warpPipes) {
    stampPipe(grid, tx, 3);
    pipes.push({
      tx,
      height: 3,
      dest: { levelId: "1-4", enter: "pipe-down" },
    });
  }

  const walkers = [16, 20, 34, 52, 66, 76, 88, 110, 118, 134, 138];
  for (const tx of walkers) entities.push({ kind: "walker", tx, ty: GROUND_ROW });
  entities.push({ kind: "troopa", tx: 30, ty: GROUND_ROW, color: "green" });
  entities.push({ kind: "troopa", tx: 72, ty: GROUND_ROW, color: "green" });
  entities.push({ kind: "troopa", tx: 136, ty: GROUND_ROW, color: "green" });

  return {
    id: "1-2",
    worldLabel: "1-2",
    theme: "underground",
    time: 400,
    tiles: freeze(grid),
    entities,
    pipes,
    playerSpawn: { tx: 5, ty: GROUND_ROW },
    exitX: 187,
    next: "1-3",
  };
}
